import React from 'react';
import proptypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@one-thd/sui-atomic-components';
import { useMessage } from '../../hooks/useMessage';
import { usePromoCart } from '../../hooks/usePromoCart';
import { usePromoModel } from '../../hooks/usePromoModel';
import { useGroupedPromoModel } from '../../hooks/useGroupedPromoModel';
import { MESSAGE_KEY } from '../../utils/constants';
import { noop } from '../../utils/promo-utils';
import {
  getGroupDataByAnchor,
  isAddToBundleDisabled,
  triggerAddToBundleEvent,
} from '../../utils/promo-grouped-utils';

const { arrayOf, bool, func, string } = proptypes;

export const AddMultipleToBundleButton = ({
  fullWidth,
  itemIds,
  onComplete: onCompleteProp,
  simpleATCMessage
}) => {
  const {
    setIsCartLoading,
  } = usePromoCart();
  const {
    allListProductsAndAnchor,
    isMultiSelect,
    isBogo,
  } = usePromoModel();
  const {
    groupedItemsByAnchor,
    currentActiveGroup,
  } = useGroupedPromoModel();

  const addToMultipleButtonText = useMessage(
    MESSAGE_KEY.addToBundleButton,
    simpleATCMessage || isBogo ? null : itemIds.length
  );

  const isDisabled = isAddToBundleDisabled({
    itemIds,
    groupedItemsByAnchor,
    currentActiveGroup,
  });

  const onClick = () => {
    const hasNonApplianceItem = itemIds.some((itemId) => {
      return allListProductsAndAnchor.get(itemId);
    });

    if (!isMultiSelect && hasNonApplianceItem) setIsCartLoading(true);

    window.groupedItemsAddedToBundle = true;

    // Data is transferred via LIFE_CYCLE_EVENT_BUS event
    const groupData = getGroupDataByAnchor(groupedItemsByAnchor, currentActiveGroup);
    const currentPromotionId = Number(groupData?.promotionId);
    const currentPromotionTag = groupData?.promotionProducts?.promotions?.[0]?.experienceTag;

    triggerAddToBundleEvent({
      itemIds,
      allListProductsAndAnchor,
      promotionId: currentPromotionId,
      promotionTag: currentPromotionTag,
    });

    onCompleteProp();
  };

  const addToBundleButtonClasses = classnames({ 'sui-w-full': fullWidth });

  // Wrapper div is due to an issue within AddToCart where there is another unnecessary wrapper div
  return (
    <div className={addToBundleButtonClasses}>
      <Button fullWidth onClick={onClick} disabled={isDisabled}>
        {addToMultipleButtonText}
      </Button>
    </div>
  );
};

AddMultipleToBundleButton.displayName = 'AddMultipleToBundleButton';

AddMultipleToBundleButton.propTypes = {
  fullWidth: bool,
  itemIds: arrayOf(string),
  onComplete: func,
  simpleATCMessage: bool,
};

AddMultipleToBundleButton.defaultProps = {
  fullWidth: true,
  itemIds: [],
  onComplete: noop,
  simpleATCMessage: false,
};
